import React from 'react';
import PropTypes from 'prop-types';

import BaseRolesAndPrivileges from 'UserRegistration/components/RegistrationSteps/RolesAndPrivileges/BaseRolesAndPrivileges';

/**
 * Displays the Add Contact version of the Billing Information section.
 * 
 * @param {object} props 
 */
function AddContactRolesAndPrivileges(props) {

    return (

        <BaseRolesAndPrivileges
            {...props}
        />

    );

}

AddContactRolesAndPrivileges.propTypes = {
    /** A key that corresponds to a property of the registrationModel object. @see UserRegistration.js */
    modelKey: PropTypes.string,
    /** The total number of configurable sections currently loaded in the instance of UserRegistration. */
    sectionCount: PropTypes.number,
    /** The position of this section in relation to other sections in the entire instance of UserRegistration. */
    sectionNumber: PropTypes.number
};

export default AddContactRolesAndPrivileges;